export const buildDateList = () => {
  const myDatelist = [];
  // add number of days to date
  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  // remember January is month 0
  const today = new Date();
  const today_month = today.getMonth();
  const grfsmonth = today_month != 11 ? today_month + 1 : 0;		    // Graph starting month
  const grfsdate = new Date(2021, grfsmonth, 1);					    // standardized to 2021
  for (let x = 0; x < 365; x++) { 
    const dtdate = addDays(grfsdate, x);
    myDatelist.push(dtdate);
  };
  return myDatelist;
};